import type { JSX } from 'react';

import styles from './styles.module.css';

export function CareCoordination(): JSX.Element {
  return (
    <section className={`${styles.secPad} ${styles.coord}`} id="coordination">
      <div className={`${styles.wrap} ${styles.center}`}>
        <span className={styles.eyebrow}>Care coordination</span>
        <h2 className={styles.sectionH2}>We keep you in the loop — and make compliance easy</h2>
        <p className={styles.coordIntro}>
          Once your patient is enrolled, NourishedRx handles the coordination and supports
          compliance — so the part that's left to you stays simple.
        </p>
      </div>
      <div className={styles.wrap}>
        <div className={styles.coordGrid}>
          <div className={styles.cc}>
            <div className={styles.ccIc}>
              <svg viewBox="0 0 24 24" fill="none" strokeWidth="2">
                <rect x="3" y="4" width="18" height="17" rx="2" />
                <path d="M8 2v4M16 2v4M3 10h18M9 15l2 2 4-4" />
              </svg>
            </div>
            <div>
              <h4>Quarterly lab reminders</h4>
              <p>
                You and your patient both get reminded when labs are due — four windows a year,
                tracked automatically.
              </p>
            </div>
          </div>
          <div className={styles.cc}>
            <div className={styles.ccIc}>
              <svg viewBox="0 0 24 24" fill="none" strokeWidth="2">
                <rect x="3" y="3" width="18" height="18" rx="2" />
                <path d="M3 9h18M8 14l2 2 4-4" />
              </svg>
            </div>
            <div>
              <h4>A provider portal</h4>
              <p>
                See your patient's engagement, lab history, and session attendance — without ever
                logging into the member app.
              </p>
            </div>
          </div>
          <div className={styles.cc}>
            <div className={styles.ccIc}>
              <svg viewBox="0 0 24 24" fill="none" strokeWidth="2">
                <path d="M12 2a7 7 0 0 0-7 7c0 5-2 6-2 6h18s-2-1-2-6a7 7 0 0 0-7-7Z" />
                <path d="M10 21a2 2 0 0 0 4 0" />
              </svg>
            </div>
            <div>
              <h4>Milestone &amp; escalation alerts</h4>
              <p>
                Automatic notifications when your patient hits a milestone, submits labs, or may
                need your attention.
              </p>
            </div>
          </div>
          <div className={styles.cc}>
            <div className={styles.ccIc}>
              <svg viewBox="0 0 24 24" fill="none" strokeWidth="2">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8Z" />
                <path d="M14 2v6h6M9 15l2 2 4-4" />
              </svg>
            </div>
            <div>
              <h4>Year-end outcomes summary</h4>
              <p>
                A complete summary for your patient's care record, plus the outcome data compiled
                and ready to support your reporting.
              </p>
            </div>
          </div>
        </div>
        <div className={styles.burden}>
          <span className={styles.burdenDot}>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="var(--coral-dark)"
              strokeWidth="2.2"
            >
              <path d="M20 6 9 17l-5-5" />
            </svg>
          </span>
          <span className={styles.burdenBig}>
            The referral takes 5 minutes. From there, NourishedRx handles the coordination and
            supports compliance — keeping your part simple.
          </span>
        </div>
      </div>
    </section>
  );
}
